import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import SimpleCenteredHeaderSection from '@/components/HeaderSection/SimpleCenteredHeaderSection';
import { NextSeo, ProductJsonLd, OrganizationJsonLd } from 'next-seo';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import { H4 } from '@/components/Element/Heading';
import LinkButton from '@/components/Button/LinkButton';
import Center from '@/components/Element/Center';
import { reviews } from 'data/static';
import SimpleReviewBlock from '@/components/Review/SimpleReviewBlock';
import CTACard from '@/components/Review/CTACard';

export default function Page() {
  const reviewBlocks = reviews.map((review, index) => (
    <>
      {index === 5 && <CTACard />}
      {index === 10 && <CTACard />}
      <SimpleReviewBlock
        key={`review-${index}`}
        review={review}
        index={index}
      />
    </>
  ));

  return (
    <>
      <NextSeo
        title="Home Solar Reviews - EnergyPal"
        description="Check out EnergyPal's solar reviews! See satisfied customers' experiences and leave your own review and share your experience. Join the solar revolution today!"
        canonical="https://www.energypal.com/reviews"
        openGraph={{
          url: 'https://www.energypal.com/reviews',
          title: 'EnergyPal Reviews ⭐⭐⭐⭐⭐',
          description:
            "Read reviews from EnergyPal's happy solar customers and leave a review of your own.",
        }}
      />
      <OrganizationJsonLd
        type="Corporation"
        name={'EnergyPal'}
        legalName={'EnergyPal'}
        logo={'https://energypal.com/brand/EnergyPal-Logo-FullName-blue.png'}
        address={'8005 Financial Dr, Suite 323, Brampton, On, Canada L6Y6A1'}
        url={`https://energypal.com/reviews`}
      />
      {reviews.map((review, index) => (
        <ProductJsonLd
          key={`review-${index}`}
          productName="EnergyPal"
          brand="EnergyPal"
          image={[
            'https://energypal.com/brand/EnergyPal-Logo-FullName-blue.png',
          ]}
          aggregateRating={{
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '1481',
          }}
          review={[
            {
              '@type': 'Review',
              author: {
                '@type': 'Person',
                name: review.name,
              },
              reviewRating: {
                '@type': 'Rating',
                ratingValue: review.rating,
              },
              reviewBody: review.comment,
            },
          ]}
          offers={{
            '@type': 'Offer',
            availability: 'https://schema.org/InStock',
            url: 'https://www.energypal.com/',
            validFrom: '2025-01-01',
            validThrough: '2026-01-01',
          }}
        />
      ))}

      <SimpleCenteredHeaderSection
        dark
        supTitle="EnergyPal"
        title="Our Reviews"
        subTitle="Thank you for going solar with EnergyPal"
        reviewCount={true}
      />

      <CenteredContentSection>
        <Center>
          <H4>Had a great experience with EnergyPal?</H4>
          <LinkButton
            href="https://g.page/EnergyPal/review?rc"
            className="no-underline"
          >
            Leave a Review
          </LinkButton>
        </Center>
        <div className="not-prose">{reviewBlocks}</div>
      </CenteredContentSection>
      <VerticalLeadFormSection />
    </>
  );
}
